import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from '@/pages/home/components/HeroSection';
import CategorySection from '@/pages/home/components/CategorySection';
import IntroSection from '@/pages/home/components/IntroSection';
import BenefitsSection from '@/pages/home/components/BenefitsSection';
import GuideSection from '@/pages/home/components/GuideSection';
import ArticleCardsSection from '@/pages/home/components/ArticleCardsSection';
import CTASection from '@/pages/home/components/CTASection';
import JsonLd from '@/components/base/JsonLd';

export default function Home() {
  const websiteJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'SugargooSheet',
    url: 'https://sugargoosheet.bond',
    description: 'Discover the best Sugargoo spreadsheet resources, curated product finds, shopping guides, reviews, and expert tips for international buyers.',
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: 'https://sugargoosheet.bond/search?q={search_term_string}',
      },
      'query-input': 'required name=search_term_string',
    },
  };

  const organizationJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'SugargooSheet',
    url: 'https://sugargoosheet.bond',
    logo: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/1fc56da0b352904925ac780066826afe.jpeg',
    description: 'Your trusted resource hub for Sugargoo spreadsheet discoveries, curated product finds, and expert shopping guides for international buyers.',
  };

  return (
    <>
      <Navbar />
      <JsonLd data={websiteJsonLd} />
      <JsonLd data={organizationJsonLd} />
      <main>
        <HeroSection />
        <CategorySection />
        <IntroSection />
        <BenefitsSection />
        <ArticleCardsSection />
        <GuideSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}